import { API_AUTH } from "./common";

const ThuocTinhTaiSanApi = {
  list: ({ loaiTaiSan }) =>
    API_AUTH.get(
      `quanlytaisan/danh-sach-thuoc-tinh-loai-tai-san?loaiTaiSan=${loaiTaiSan}`,
      {}
    ),

  listThuocTinhTaiSan: (loaiTaiSan) =>
    API_AUTH.get(
      `quanlytaisan/danh-sach-thuoc-tinh-loai-tai-san?loaiTaiSan=${loaiTaiSan}`,
      {}
    ),
};

export default ThuocTinhTaiSanApi;
